export const elgs = [
  { label: 'Amazon People with Disabilities (AmazonPwD)', value: 'PWD' },
  { label: 'Amazon Women in Engineering (AWE)', value: 'AWE' },
  { label: 'Arabs at Amazon', value: 'Arabs@' },
  { label: 'Asians at Amazon (AatA)', value: 'Asians@' },
  { label: 'Black Employee Network (BEN)', value: 'BEN' },
  { label: 'Body Positive Peers', value: 'BPP' },
  { label: 'Caribbean Connection', value: 'Caribbean Connection' },
  { label: 'Connect at Amazon', value: 'Connect@' },
  { label: 'Families at Amazon', value: 'Families@' },
  { label: 'glamazon', value: 'Glamazon' },
  { label: 'Hindus at Amazon', value: 'Hindus@' },
  { label: 'Indigenous at Amazon', value: 'Indigenous@' },
  { label: 'Jewish at Amazon', value: 'Jewish@' },
  { label: 'Latinos at Amazon', value: 'Latinos@' },
  { label: 'Mental Health and Well-Being (MHW)', value: 'MHW' },
  { label: 'Sustainability at Amazon', value: 'Sustainability' },
  { label: 'Together at Amazon', value: 'Inclusion Ambassadors' },
  { label: 'Trans at Amazon', value: 'Trans@' },
  { label: 'Warriors at Amazon', value: 'Warriors@' },
  { label: 'Women in Finance Initiative (WiFi)', value: 'Women in Finance' },
  { label: 'Women at Amazon', value: 'Women@' },
];
